async function newsletterBotCheck(form) {
    console.log("form: ", form);
    let stopBotCat = document.getElementById('gotchaBot');
    console.log("StopBot: ", stopBotCat.value);
    if(stopBotCat.value != null && stopBotCat.value != "") {
        let formData = new FormData();
        let formElements = form.elements;
        console.log("formElements: ", formElements);
        for (let i = 0; i < formElements.length; i++) {
            let element = formElements[i];
            let name = element.name;
            let value = element.value;
            formData.append(name, value);
        }
    $.ajax({
          url: 'https://formscabinetstogo.com/bot_form.php' ,
          method: 'POST',
          data: formData,
          processData: false,
          contentType: false,
          success: function(response) {
              console.log('Bot data processed successfully');
          },
          error: function(xhr, status, error) {
              console.log('Error processing bot data: ', error);
          }
        });
    return false;
  } else {
    let newsCheck = etcStoreValidate(form);
    return newsCheck;
  }
}